/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:52
 */
import EpochColumn from "./EpochColumn";

class DateColumn extends EpochColumn {

  constructor(params) {
    params.format = 'd/m/Y';
    params.selector = '.js-column-date';
    super(params);
  }

}

export default DateColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/DateColumn.js